// Tipos de erro
export enum ErrorType {
  NETWORK = 'NETWORK',
  TIMEOUT = 'TIMEOUT',
  UNAUTHORIZED = 'UNAUTHORIZED',
  SERVER_ERROR = 'SERVER_ERROR',
  VALIDATION = 'VALIDATION',
  CONFLICT = 'CONFLICT',
  NOT_FOUND = 'NOT_FOUND',
  GENERIC = 'GENERIC'
}

// Mensagens de erro organizadas por contexto
export const AUTH_ERROR_MESSAGES = {
  [ErrorType.NETWORK]: 'Erro de conexão. Verifique sua internet e tente novamente.',
  [ErrorType.TIMEOUT]: 'Tempo limite excedido. Tente novamente.',
  [ErrorType.UNAUTHORIZED]: 'Usuário ou senha incorretos.',
  [ErrorType.SERVER_ERROR]: 'Erro interno do servidor. Tente novamente mais tarde.',
  [ErrorType.VALIDATION]: 'Dados inválidos. Verifique as informações e tente novamente.',
  [ErrorType.CONFLICT]: 'Dados já existem no sistema.',
  [ErrorType.NOT_FOUND]: 'Serviço não encontrado.',
  [ErrorType.GENERIC]: 'Ocorreu um erro inesperado. Tente novamente.'
} as const

export const REGISTER_ERROR_MESSAGES = {
  [ErrorType.NETWORK]: 'Erro de conexão. Verifique sua internet e tente novamente.',
  [ErrorType.TIMEOUT]: 'Tempo limite excedido. Tente novamente.',
  [ErrorType.SERVER_ERROR]: 'Erro interno do servidor. Tente novamente mais tarde.',
  [ErrorType.VALIDATION]: 'Dados inválidos. Verifique as informações e tente novamente.',
  [ErrorType.CONFLICT]: {
    USERNAME: 'Nome de usuário já existe. Tente outro.',
    FARM: 'Fazenda já existe com esses dados.',
    GENERIC: 'Dados já existem no sistema.'
  },
  [ErrorType.GENERIC]: 'Ocorreu um erro durante o cadastro. Tente novamente.'
} as const

// Função para identificar o tipo de erro baseado no erro do Axios
export const getErrorType = (error: any): ErrorType => {
  // Erro de rede
  if (
    error?.code === 'NETWORK_ERROR' ||
    error?.message?.includes('Network') ||
    error?.message?.includes('fetch') ||
    error?.code === 'ERR_NETWORK'
  ) {
    return ErrorType.NETWORK
  }

  // Erro de timeout
  if (error?.code === 'ECONNABORTED' || error?.message?.includes('timeout') || error?.code === 'ERR_TIMEOUT') {
    return ErrorType.TIMEOUT
  }

  // Erro de autenticação
  if (error?.response?.status === 401 || error?.message?.includes('401') || error?.message?.includes('Unauthorized')) {
    return ErrorType.UNAUTHORIZED
  }

  // Erro de conflito
  if (
    error?.response?.status === 409 ||
    error?.message?.includes('já existe') ||
    error?.message?.includes('already exists')
  ) {
    return ErrorType.CONFLICT
  }

  // Erro não encontrado
  if (error?.response?.status === 404) {
    return ErrorType.NOT_FOUND
  }

  // Erro do servidor
  if (error?.response?.status >= 500) {
    return ErrorType.SERVER_ERROR
  }

  // Erro de validação
  if (error?.response?.status === 400 || error?.response?.status === 422) {
    return ErrorType.VALIDATION
  }

  return ErrorType.GENERIC
}

// Função para obter mensagem de erro específica para login
export const getAuthErrorMessage = (error: any): string => {
  const errorType = getErrorType(error)
  return AUTH_ERROR_MESSAGES[errorType]
}

// Função para obter mensagem de erro específica para registro
export const getRegisterErrorMessage = (error: any): string => {
  const errorType = getErrorType(error)

  if (errorType === ErrorType.CONFLICT) {
    // Verificar se é conflito de username ou fazenda
    if (error?.message?.includes('username') || error?.message?.includes('usuário')) {
      return REGISTER_ERROR_MESSAGES[ErrorType.CONFLICT].USERNAME
    } else if (error?.message?.includes('fazenda')) {
      return REGISTER_ERROR_MESSAGES[ErrorType.CONFLICT].FARM
    }
    return REGISTER_ERROR_MESSAGES[ErrorType.CONFLICT].GENERIC
  }

  return REGISTER_ERROR_MESSAGES[errorType]
}

// Função para obter mensagem de erro específica para validação
export const getValidationErrorMessage = (error: any): string => {
  const errorType = getErrorType(error)

  if (errorType === ErrorType.VALIDATION) {
    // Mensagens específicas de validação
    if (error?.message?.includes('senha')) {
      return 'A senha deve ter pelo menos 6 caracteres'
    }
    if (error?.message?.includes('username')) {
      return 'Nome de usuário é obrigatório'
    }
    if (error?.message?.includes('nome')) {
      return 'Nome é obrigatório'
    }
    return 'Dados inválidos. Verifique as informações e tente novamente.'
  }

  return AUTH_ERROR_MESSAGES[errorType]
}
